import { render, staticRenderFns } from "./ImageTriviaV2.vue?vue&type=template&id=01c8a026&scoped=true&"
import script from "./ImageTriviaV2.vue?vue&type=script&lang=js&"
export * from "./ImageTriviaV2.vue?vue&type=script&lang=js&"
import style0 from "./ImageTriviaV2.vue?vue&type=style&index=0&id=01c8a026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c8a026",
  null
  
)

export default component.exports